import React, { FC, useEffect } from 'react';
import Form from '../../components/Form/Form';
import { ValidatorsE } from '../../components/Form/yupValidations';
import { P } from '../../components/Text/Text';
import { FormFieldT } from '../../models/models';
import usePopup from './../../utils/hooks/usePopup';
import { useCreateProductionCompanyShortMutation, useLazyGetAllProductionCompaniesQuery } from '../../api/productionCompaniesAPI';
import { toast } from 'react-toastify';
import { TOAST_DURATION } from '../../utils/helpers/constants';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectSelectedProductionCompany } from '../../store/selectors/deliveryWizardSelector';
import { setSelectedProductionCompany } from '../../store/slices/deliveryWizardSlice';

import styles from './createNewProductionCompanyShort.module.scss';

type CreateNewProductionCompanyShortBodyPropTypes = {
    prodCompanyName?: string;
};

const CreateNewProductionCompanyShortBody: FC<CreateNewProductionCompanyShortBodyPropTypes> = (props) => {
    const { prodCompanyName } = props;
    const fields: FormFieldT[] = [
        {
            label: 'Name',
            validation: ValidatorsE.REQUIRED_STRING,
            defaultValue: prodCompanyName,
        },
        {
            label: 'Email',
            validation: ValidatorsE.EMAIL,
            extraContent: () => (
                <P className={styles.hint}>
                    An invitation will be sent to the email address you provide. The invitation will allow the production company to register for JumboMedia and monitor the entire progress of the project.
                </P>
            )
        },
    ];
    const { removePopup } = usePopup();
    const [createProductionCompany] = useCreateProductionCompanyShortMutation();
    const [getProductionCompanies] = useLazyGetAllProductionCompaniesQuery();
    const dispatch = useAppDispatch();
    const selectedProductionCompany = useAppSelector(selectSelectedProductionCompany);

    useEffect(() => {
        const nameField = document.getElementsByName('name')?.[0];

        if (nameField) {
            nameField.focus();
        }
    }, []);

    const handleSubmit = async (data: any) => {
        const body = {
            Name: data.name,
            Email: data.email,
            Id: null,
        };

        try {
            const res: any = await createProductionCompany(body);
            if (!res.error) {
                await getProductionCompanies({ asSelectOptions: true });
                // const setProdCompanyEvent = new CustomEvent('setproductionCompany', {
                //     detail: {
                //         id: res.data.Id,
                //         name: res.data.Name,
                //     },
                // });
                // const setProdCompanySelectEvent = new CustomEvent('setproductionCompanyselect', {
                //     detail: {
                //         id: res.data.Id,
                //         name: res.data.Name,
                //     },
                // });

                // document.dispatchEvent(setProdCompanyEvent);
                // document.dispatchEvent(setProdCompanySelectEvent);
                dispatch(setSelectedProductionCompany({
                    value: res.data.Id,
                    label: res.data.Name,
                }));
                removePopup();
                toast('Successfully created', {
                    type: 'success',
                    autoClose: TOAST_DURATION
                });
            }
        } catch (e: any) {
            console.log(e);
        }
    }
    return (
        <Form
            fields={fields}
            formID='create-short-prod-company'
            onSubmit={handleSubmit}
            columns={1}
        />
    );
};

export default CreateNewProductionCompanyShortBody;